"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseComponent_1 = require("./base/baseComponent");
var ko = require("knockout");
var $ = require("jquery");
var dateTimeUtils_1 = require("../utils/dateTimeUtils");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var MobileWidgetComponent = (function (_super) {
    __extends(MobileWidgetComponent, _super);
    function MobileWidgetComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.isLoading = ko.observable(true);
        this.widgetHtml = ko.observable();
        this.url = params.url;
        this.title = params.title;
        this.requestParams = params.rParams || {};
        this.localeStorageParams = params.lsParams || {};
        ajaxUtils_1.AjaxUtils.get(this.url, this.requestParams)
            .done(function (result) {
            if (!result.isSuccessful) {
                alert(result.messages[0]);
                return;
            }
            _this.widgetHtml(result.data.html);
            setTimeout(function () {
                var $content = $(element).find(".widget-content");
                $content.addClass("in");
                dateTimeUtils_1.default.displayTime($content);
            });
        }).always(function () {
            _this.isLoading(false);
        });
    }
    return MobileWidgetComponent;
}(baseComponent_1.default));
ko.components.register("mobile-widget", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MobileWidgetComponent;
//# sourceMappingURL=mobileWidget.js.map